import React from 'react';
import { useGetUserByVerificationCodeQuery, useChangePasswordMutation } from 'redux/api/authApi';
import { useParams } from 'react-router-dom';
import { UserPassword, FullScreenLoader } from "components";
import { Box } from "@mui/material";
/**
 * Password to set user password after creation
 */

const UserNewPasswordPage = () => {

  const { verificationCode } = useParams();

  const { data: user, isLoading: isGetUserLoading } = useGetUserByVerificationCodeQuery(String(verificationCode));
  const [setPassword, { isSuccess: isSetPasswordSuccess, isLoading: isSetPasswordLoading }] = useChangePasswordMutation();

  // Submit handler

  const setNewPasswordHandler = (password: string) => {
    setPassword({userId: String(user?.id), password });
  }

  if (isGetUserLoading) {
    <FullScreenLoader />
  }

  return (
    <Box
    sx={{
      width: "80%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "3rem",
      "@media (min-width:900px)": {
        width: "80%", // Para md
      },
      "@media (min-width:1200px)": {
        width: "60%",
      },
      "@media (min-width:1536px)": {
        width: "60%", // Para xl
      },
    }}
  >
        {/* If password is not set, shows form, and if is set, shows form success view */}

        {isSetPasswordSuccess && <UserPassword.FormSuccess />}
        {!isSetPasswordSuccess && <UserPassword.Form isLoading={isSetPasswordLoading} onSubmit={setNewPasswordHandler} />}
    </Box>
  );
};

export default UserNewPasswordPage;